import { QueryClient } from '@tanstack/react-query';

/**
 * The app's one TanStack Query client — exported so non-React modules (the
 * zustand stores) can invalidate server state, e.g. the Team planet queries
 * when one of the player's own fleets is sent or lands.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            retry: 1,
        },
    },
});
